<template>
  <div>
    <h1>Monthly QR Registration</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'MAIN DEALER'"
      :simple_date="true"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <div class="mt-5" style="background-color: black; color:white; padding:0.5%;">
      <h3 style="margin:0;">VEHICLE MAPPING</h3>
    </div>
    <!-- Registered By Main Dealer Start -->
    <div class="innerBox mt-2">
      <vehicle-mapping
        :filterUrl="filterUrl"
      ></vehicle-mapping>
    </div>
    <!-- Registered By Main Dealer End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import vehicleMapping from './children/vehicleMapping'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      vehicleMapping,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>